import { Field, InjectedFormProps, reduxForm } from 'redux-form';
import * as React from 'react';
import { debtTypeMap } from './debtTypes';
import { decimal, required } from '../../shared/Forms/validations';
import Grid from '@material-ui/core/Grid/Grid';
import Button from '@material-ui/core/Button/Button';
import CircularProgress from '@material-ui/core/CircularProgress/CircularProgress';
import {
  DatePickerField,
  FullWidthTextField,
  SelectField
} from '../../shared/Forms/FullWidthForm/fullWidthFormComponents';

interface AddDebtFormProps {
  sendingDebt: boolean;
  back: () => void;
}

const AddDebtForm: React.FunctionComponent<
  AddDebtFormProps & InjectedFormProps<{}, AddDebtFormProps>
> = ({ handleSubmit, back, sendingDebt }) => (
  <form onSubmit={handleSubmit}>
    <Grid container alignItems="center" justify="center">
      <Grid item xs={8} sm={6} md={4} container direction="column">
        <Field
          name="name"
          type="text"
          component={FullWidthTextField}
          label="Debt Name"
          validate={required}
        />
        <Field
          name="type"
          type="text"
          dataMap={debtTypeMap}
          component={SelectField}
          label="Loan Type"
          validate={required}
        />
        <Field
          name="currentBalance"
          type="number"
          component={FullWidthTextField}
          label="Statement Balance"
          validate={[required, decimal]}
          parse={value => (value ? Number(value) : value)}
        />
        <Field
          name="minimumPayment"
          type="number"
          component={FullWidthTextField}
          label="Minimum Payment Due"
          validate={[decimal]}
          parse={value => (value ? Number(value) : value)}
        />
        <Field
          name="paymentDueDate"
          type="date"
          component={DatePickerField}
          label="Payment Due Date"
        />
        <Field
          name="apr"
          type="number"
          component={FullWidthTextField}
          label="APR Percentage"
          parse={value => (value ? Number(value) : value)}
        />
        <Grid style={{ margin: '20px 0' }} container justify="space-around">
          <Button size="large" variant="contained" onClick={() => back()}>
            Go Back
          </Button>
          <Button
            size="large"
            variant="contained"
            color="primary"
            type="submit"
            disabled={sendingDebt}>
            {sendingDebt ? <CircularProgress size={20} /> : 'Submit'}
          </Button>
        </Grid>
      </Grid>
    </Grid>
  </form>
);

export default reduxForm<{}, AddDebtFormProps>({
  form: 'debtForm'
})(AddDebtForm);
